<template>
  <div>
    <table class="unstriped hover boss-table">
      <thead>
        <tr
          data-test="jobs-title"
        >
          <th class="boss-table-head-center text-nowrap">
            求人ID
          </th>
          <th class="boss-table-head-center text-nowrap">
            管理用求人名
          </th>
          <th class="boss-table-head-center text-nowrap">
            求人名
          </th>
          <th class="boss-table-head-center text-nowrap">
            掲載期間
          </th>
          <th class="boss-table-head-center text-nowrap">
            公開する面接情報
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(job, i) in jobs"
          :key="i"
          data-test="jobs"
        >
          <td
            class="boss-table-data boss-calendar-jobs-body-id"
            data-test="job-id"
          >
            {{ job.jobId }}
          </td>
          <td
            class="boss-table-data"
            data-test="administration-name"
          >
            {{ job.jobAdministrationName }}
          </td>
          <td
            class="boss-table-data left"
            data-test="name"
          >
            {{ job.jobName }}
          </td>
          <td
            class="boss-table-data"
            data-test="publishing-date"
          >
            {{ job.startDate | formatDate }} ~ {{ job.endDate | formatDate }}
          </td>
          <td
            class="boss-table-data"
            :class="{'pega-empty-select required' : job.jobInterviewId == null && !job.isOriginalEntryForm}"
            :data-test="`not-set-interview-class-${i}`"
          >
            <div v-if="job.isOriginalEntryForm">
              <span
                :data-test="`original-entry-form-${i}`"
              >専用応募フォームを設定している求人は、<br>面接情報を公開できません。</span>
            </div>
            <div v-else>
              <div
                v-if="job.jobInterviewId === null"
                class="boss-text boss-align-left pega-ml-1"
              >
                <span
                  class="boss-text boss-annotation-text"
                  :data-test="`not-set-interview-text-${i}`"
                >※面接情報が公開されていません</span>
              </div>
              <select
                v-model="job.jobInterviewId"
                :data-test="`interview-pull-down-${i}`"
                class="boss-input-select js-check-default pega-interview-pull-down"
                @change="updateInterview(job.jobId, job.jobInterviewId)"
              >
                <option
                  v-for="(interview ,j) in interviews"
                  :key="`interview-pull-down-${i}-${j}`"
                  :value="interview.id"
                  :data-test="`interview-pull-down-option-${i}-${j}`"
                >
                  {{ interview.name }}
                </option>
                <option :value="null">
                  選択してください
                </option>
              </select>
              <div
                class="boss-text boss-align-left pega-ml-1"
              >
                <router-link
                  v-if="job.jobInterviewId == null"
                  :to="{ name: 'interviewInformationRegister' }"
                  :data-test="`registration-interview-${i}`"
                >
                  新規登録する
                </router-link>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  filters: {
    formatDate (val) {
      return dayjs(val).format('YYYY/MM/DD')
    }
  },
  props: {
    jobs: {
      type: Array,
      required: true
    },
    interviews: {
      type: Array,
      required: true
    }
  },
  methods: {
    updateInterview (jobId, jobInterviewId) {
      this.$http.secured.put(`/interview/jobs/${jobId}`, jobInterviewId).then(response => {
        this.$toasted.global.success({ message: '公開する面接情報を変更しました。' })
        this.$emit('update', jobId, jobInterviewId)
      })
    }
  }
}
</script>
